// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3G3x5","requiredAsterisk":"Info_requiredAsterisk__37b_w"};